import React from 'react';
import { css } from '@linaria/core';
import classNames from 'classnames';

const fieldset = css`
  margin-bottom: 20px;
`;

const errorWrapper = css`
  margin: 10px 0;
  padding-left: 15px;
  position: relative;

  &::before {
    background-color: #d4351c;
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    top: 0;
    width: 5px;
  }
`;

export default function FormFieldset({
  children,
  className,
  hasError,
  ...props
}) {
  const fieldsetElement = (
    <fieldset className={classNames(fieldset, className)} {...props}>
      {children}
    </fieldset>
  );

  // This is required due to a fieldset's special legend rendering behavior.
  if (hasError) {
    return <div className={errorWrapper}>{fieldsetElement}</div>;
  }

  return fieldsetElement;
}
